import helper from '../../../helpers/helper';
import select2Helpers from '../../../helpers/select2_helpers';

document.addEventListener('turbolinks:load', () => {
  const $sourceEmploymentCompanyId = $('#source_employment_company_id:visible');

  if (
    helper.notPresent($sourceEmploymentCompanyId)
  ) {
    return;
  }

  select2Helpers.setupSelect2($sourceEmploymentCompanyId, '/api/internal/jsonapi/companies?policy_used=associable', select2Helpers.formatCompanies);
});
